import Header from './Header.jsx'
import Footer from './Footer.jsx'
import FeedbackForm from './FeedbackForm.jsx'
import OfferSection from './OfferSection.jsx'
import DocumentMeta from './DocumentMeta.jsx'
import { trackEvent } from './lib/analytics'

function AboutPage() {
  return (
    <div className="bg-gradient-to-br from-white to-gray-50 text-gray-900 min-h-screen">
      <DocumentMeta
        title="Σχετικά με το Πανελλήνιες+"
        description="Το Πανελλήνιες+ είναι ένα δωρεάν εργαλείο για μαθητές που δίνουν Πανελλήνιες, με βάσεις, θέματα και υπολογισμό μορίων."
        canonical="https://www.panellhniesplus.gr/about"
      />
      <Header />

      <main className="px-4 sm:px-6 py-12 sm:py-16 max-w-3xl mx-auto text-gray-800">
        <h1 className="text-2xl md:text-4xl font-bold mb-6 md:mb-8 text-gray-800">
          Σχετικά με το{' '}
          <span className="font-bold text-gray-800">
            Panellhnies
            <sup className="text-gray-800 font-bold">+</sup>
          </span>
        </h1>

        <p className="mb-5 leading-relaxed text-base md:text-lg">
          Το{' '}
          <span className="font-bold text-gray-800">
            Panellhnies
            <sup className="text-gray-600 font-bold">+</sup>
          </span>{' '}
          είναι μια μοντέρνα και εύχρηστη εφαρμογή για μαθητές που προετοιμάζονται για τις Πανελλήνιες.
          Στόχος μας είναι να συγκεντρώσουμε σε ένα σημείο, καθαρά και χωρίς κόστος, όλη την
          πληροφορία που χρειάζεται ένας υποψήφιος για να πάρει σωστές αποφάσεις: τις βάσεις
          εισαγωγής, τα θέματα των προηγούμενων ετών, τον υπολογισμό μορίων και το πρόγραμμα
          των εξετάσεων.
        </p>

        <OfferSection />

        <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mt-10 mb-3">
          Από πού προέρχονται τα δεδομένα
        </h2>
        <p className="mb-6 leading-relaxed text-base md:text-lg">
          Τα στοιχεία των βάσεων και τα θέματα βασίζονται σε επίσημες πηγές των Πανελληνίων
          εξετάσεων. Ενημερώνουμε την πλατφόρμα μετά από κάθε νέα εξεταστική περίοδο, ώστε οι
          μαθητές να έχουν πρόσβαση σε ακριβή και επικαιροποιημένη πληροφορία. Η χρήση όλων των
          εργαλείων είναι δωρεάν και δεν απαιτεί εγγραφή.
        </p>

        {/* Donate / Support section */}
        <section className="my-10 md:my-12 p-5 md:p-6 rounded-2xl bg-white/70 shadow-sm border border-gray-100">
          <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mb-2">
            Στήριξε το{' '}
            <span className="font-bold text-gray-700">
              Panellhnies
              <sup className="text-gray-600 font-bold">+</sup>
            </span>
          </h2>
          <p className="text-gray-700 mb-4">
            Αν το εργαλείο σε βοήθησε, μπορείς να μας κεράσεις έναν καφέ ώστε να συνεχίσουμε να
            προσθέτουμε περισσότερα θέματα και να βελτιώνουμε την πλατφόρμα. Ευχαριστούμε! 🙌
          </p>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <a
              href="https://buymeacoffee.com/giannisvrno"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackEvent('donate_clicked', {
                  source: 'about_page',
                  provider: 'buymeacoffee',
                })
              }}
              className="cursor-pointer inline-flex justify-center items-center gap-2 w-full sm:w-auto px-4 py-3 rounded-xl bg-gradient-to-r from-gray-700 to-zinc-800 text-white font-semibold shadow-md hover:opacity-95 transition"
              aria-label="Buy Me a Coffee"
            >
              <span className="text-xl" aria-hidden>☕</span>
              Buy Me a Coffee
            </a>
          </div>
        </section>

        <FeedbackForm />
      </main>

      <Footer />
    </div>
  )
}

export default AboutPage
